import React, { useRef, useState, useEffect } from 'react';
import { Input, notification, Select, Button, Typography } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import './IssueCard.css';
import { wrap } from 'highcharts';
const { Text } = Typography;
function IssueCard(props) {
  const isApphome = props.isApphome;
  const isReport = props.isReport;
  const [showAtrributesMore, setShowAttributesMore] = useState(false);
  const [showButtonActionsMore, setShowButtonActionsMore] = useState(false);
  const isApphomePreview = props.isApphomePreview;
  useEffect(() => {
    if (
      props.selectedAttributesDetailed &&
      props.selectedAttributesDetailed.length > 5
    ) {
      setShowAttributesMore(true);
    } else {
      setShowAttributesMore(false);
    }
  }, [props.selectedAttributesDetailed]);
  useEffect(() => {
    if (props.buttonActions.length > 5) {
      setShowButtonActionsMore(true);
    } else {
      setShowButtonActionsMore(false);
    }
  }, [props.buttonActions]);

  const truncateString = (data, truncateLength = 30) => {
    if (data.length > truncateLength)
      data = data.slice(0, truncateLength) + '...';
    return data;
  };
  const buttonActions = props.buttonActions;
  let headerAttribute = {
    name: 'Status',
    id: '10007',
  };
  const viewType = props.viewType;
  const isRealTimeNotification = props.isRealTimeNotification;
  const showSyncingText =
    props.tabKey === 'threadsync' &&
    props.showFooterMessage &&
    viewType !== 'channel'
      ? true
      : false;
  const showReporterAndWebAppLinkBlock =
    props.tabKey === 'threadsync' &&
    (props.showLinktoWebAppConfig || props.showAtMentionReporter)
      ? true
      : false;
  const notificationDisplayFormat = props.notificationDisplayFormat;
  let hideButtonActions =
    props.tabKey === 'notification' &&
    notificationDisplayFormat !== 'detailed' &&
    viewType === 'channel'
      ? true
      : false;

  if (
    (isApphome || isReport) &&
    buttonActions &&
    buttonActions.length <= 1 &&
    props.selectedAttributesDetailed.length == 0 &&
    !props.showAllDropdownActions
  ) {
    hideButtonActions = true;
  }
  const hideAttributes =
    props.tabKey === 'notification' &&
    notificationDisplayFormat === 'compact' &&
    viewType === 'channel'
      ? true
      : false;
  return (
    <div
      style={{
        padding: isApphomePreview ? 0 : 16,
        width: '100%',
      }}
    >
      <div className='issue-card'>
        <>
          {!isApphomePreview && (
            <div className='issue-card-left app-avatar'>
              <span>
                <img
                  src='https://app.troopr.io/logo/square.png'
                  alt='logo'
                  id='app-logo-card'
                />
              </span>
            </div>
          )}
          <div
            className='issue-card-right card-containts'
            style={{ marginLeft: isApphomePreview ? '0px' : '10px' }}
          >
            {!isApphomePreview && (
              <div
                className='message-header'
                style={{
                  marginTop:
                    props.tabKey === 'notification' &&
                    viewType === 'channel' &&
                    props.notificationDisplayFormat === 'compact'
                      ? '10px'
                      : '0px',
                }}
              >
                <div className='message-author'>Troopr Assistant</div>
                <div className='time-stamp'>11:30 AM</div>
              </div>
            )}

            <div className='message-blocks'>
              {props.tabKey === 'notification' &&
              viewType === 'channel' &&
              props.notificationDisplayFormat === 'compact' &&
              !isRealTimeNotification ? (
                ''
              ) : (
                <div
                  style={{ display: 'flex', alignItems: 'center' }}
                  className='issue-key-header'
                >
                  <b className='issue-key'>{props.projectKey || 'ST'}-1</b>
                  <code className='attr-1 status'>
                    {props.selectedField
                      ? props.selectedField.name
                      : headerAttribute.name}{' '}
                    value
                  </code>
                  <b className='summary'>Summary Text Goes Here</b> &nbsp;
                  &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                  {(isApphome || isReport) &&
                    props.selectedAttributesDetailed.length === 0 &&
                    props.buttonActions.length === 1 &&
                    !props.showAllDropdownActions && (
                      <Button
                        style={{
                          width: '36px',
                          height: '16px',
                          fontSize: '8px',
                          borderRadius: '2px',
                          padding: '1px 8px',
                        }}
                      >
                        {props.buttonActions[0].name}
                      </Button>
                    )}
                </div>
              )}
              {props.showDescription && props.tabKey !== 'notification' && (
                <div className='message-description'>
                  <div className='description-text'>
                    {props.tabKey === 'notification'
                      ? 'The description text will be shown here'
                      : 'The description text will be shown here below the issue summary. This text can be at most 300 characters after which it will be truncated.'}
                  </div>
                </div>
              )}
              {props.isCompact && (
                <div className='issue-key-header' style={{ marginTop: '10px' }}>
                  <b className='issue-key'>{props.projectKey || 'ST'}-2</b>
                  <code className='attr-1 status'>
                    {props.selectedField
                      ? props.selectedField.name
                      : headerAttribute.name}{' '}
                    value
                  </code>
                  <b className='summary'>Summary Text Goes Here</b>
                </div>
              )}

              {!props.isCompact && (
                <>
                  {props.selectedAttributesDetailed &&
                    props.selectedAttributesDetailed.length > 0 && (
                      <div
                        // ref={scrollRef}
                        style={{
                          maxHeight: '125px',
                          overflow: 'hidden',
                        }}
                      >
                        {!hideAttributes && (
                          <div
                            className={`${
                              (props.tabKey === 'notification' &&
                                !isRealTimeNotification) ||
                              props.attributesAllignment === 'horizontal'
                                ? 'attributeHorizontal'
                                : 'attribute-list slack-blockquote'
                            }`}
                            style={{
                              display: 'flex',
                              flexDirection: `${
                                (props.tabKey === 'notification' &&
                                  !isRealTimeNotification) ||
                                props.attributesAllignment === 'horizontal'
                                  ? 'row'
                                  : 'column'
                              }`,
                              // margin: '0.3rem',
                            }}
                          >
                            {props.selectedAttributesDetailed &&
                              props.selectedAttributesDetailed
                                .slice(0, 5)
                                .map((attribute, index) => {
                                  if (!(attribute && attribute.name)) {
                                    return <></>;
                                  }
                                  return (
                                    <div
                                      key={attribute.name}
                                      className='attribute'
                                    >
                                      <div className='attribute-name'>
                                        {attribute.name}
                                      </div>
                                      <div className='attribute-name'>
                                        :&nbsp;
                                      </div>
                                      <div className='attribute-value'>
                                        {attribute.name + ' value'}
                                      </div>
                                    </div>
                                  );
                                })}
                            {showAtrributesMore && (
                              <div>
                                <a to='/'>
                                  [... +
                                  {props.selectedAttributesDetailed.length - 5}{' '}
                                  more{' '}
                                  {props.selectedAttributesDetailed.length -
                                    5 ===
                                  1
                                    ? 'attribute'
                                    : 'attributes'}
                                  ]
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                  {props.tabKey === 'notification' &&
                    !props.disableShowLastUpdate &&
                    isRealTimeNotification && (
                      <div>
                        <a to='#'>User</a> Update =&gt; update value
                      </div>
                    )}
                  {props.tabKey === 'notification' &&
                    isRealTimeNotification === false && (
                      <div className='slack-blockquote'>
                        {props.tabKey === 'notification' &&
                        viewType === 'channel' &&
                        props.notificationDisplayFormat === 'compact' ? (
                          <div className='issue-key-header'>
                            <b className='issue-key'>
                              {props.projectKey || 'ST'}-2
                            </b>
                            <code className='attr-1 status'>
                              {props.selectedField
                                ? props.selectedField.name
                                : headerAttribute.name}{' '}
                              value
                            </code>
                            <b className='summary'>Summary Text Goes Here</b>
                          </div>
                        ) : (
                          ''
                        )}
                        <div>
                          <a to='#'>User</a> Update =&gt; update value
                        </div>
                        <div>
                          <a to='#'>User</a> Update =&gt; update value
                        </div>
                        <div>
                          <a to='#'>User</a> Update =&gt; update value
                        </div>
                      </div>
                    )}
                  {!hideButtonActions && (
                    <div
                      style={{
                        width: `${props.tabKey === 'notification'}`,
                      }}
                      className='buttonActions'
                    >
                      {buttonActions &&
                        buttonActions
                          .slice(0, 5)
                          .filter((item) => item.name)
                          .map((button, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  padding: '4px 8px',
                                  border: '1px solid #ccc',
                                  // background: '#fff',
                                  boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.016)',
                                  height: '24px',
                                  textAlign: 'center',
                                  borderRadius: 2,
                                  fontWeight: 400,
                                  lineHeight: '156.5%',
                                  whiteSpace: 'nowrap',
                                  fontSize: '10px',
                                }}
                              >
                                {truncateString(button.name, 15)}
                              </div>
                            );
                          })}

                      {props.showAllDropdownActions && (
                        <div
                          style={{
                            border: '1px solid #ccc',
                            borderRadius: 2,
                            boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.016)',
                            padding: '4px 8px',
                            width: 110,
                            height: 24,
                            textAlign: 'center',
                            fontWeight: 400,
                            fontSize: '10px',
                            lineHeight: '15.65px',
                          }}
                          disabled
                        >
                          Select an action <DownOutlined />
                        </div>
                      )}
                      {buttonActions.length > 5 && (
                        <a style={{ alignSelf: 'center' }} to='#'>
                          [... +{props.buttonActions.length - 5} more{' '}
                          {props.buttonActions.length - 5 === 1
                            ? 'action'
                            : 'actions'}
                          ]
                        </a>
                      )}
                    </div>
                  )}
                  {showSyncingText && (
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          gap: '2px',
                          marginTop: '4px',
                        }}
                      >
                        <div
                          style={{
                            fontSize: '14px',
                            dispaly: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          ⚡️
                        </div>
                        <div className='cardFooter'>
                          This message thread is actively syncing with Jira.
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </>
      </div>
      {showReporterAndWebAppLinkBlock && (
        <div style={{ marginTop: '4px' }}>
          <div className='issue-card'>
            <div className='issue-card-left app-avatar'>
              <span>
                <img
                  src='https://app.troopr.io/logo/square.png'
                  alt='logo'
                  id='app-logo-card'
                />
              </span>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'center' }}
              className='issue-card-right card-containts'
            >
              <div className='message-header'>
                <div className='message-author'>Troopr Assistant</div>
                <div className='time-stamp'>11:30 AM</div>
              </div>
            </div>
          </div>
          <div style={{ marginLeft: '37px', marginTop: '-2px' }}>
            {props.showLinktoWebAppConfig && (
              <Text type='secondary'>
                <div style={{ fontSize: '10px' }}>
                  <a to='/'>Customize</a> behaviour of threadsync in this
                  channel
                </div>
              </Text>
            )}
            {props.showAtMentionReporter && (
              <div style={{ padding: '3px 0px', fontSize: '10px' }}>
                <Text type='secondary'>
                  <UserOutlined /> Sam is the reporter
                </Text>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default IssueCard;
